export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SITE = {
  name: "Sana Steel Industries",
  tagline: "Strong. Reliable. Build to Last.",
  phone1: "+91 93412 40616",
  phone2: "+91 79752 90977",
  phone1Href: "tel:+919341240616",
  phone2Href: "tel:+917975290977",
  email: "sanasteel16@gmail.com",
  address: "Ilyas Nagar & Banashankari, Bengaluru – 560078",
  hours: "Mon – Sat · 9:00 AM – 8:00 PM",
  whatsapp:
    "https://wa.me/917975290977?text=Hello%20Sana%20Steel%20Industries%2C%20I%27d%20like%20a%20quote%20for%20your%20scaffolding%20products.",
  whatsappSecondary:
    "https://wa.me/919341240616?text=Hello%20Sana%20Steel%20Industries%2C%20I%27d%20like%20a%20quote%20for%20your%20scaffolding%20products.",
  mapEmbed: "https://maps.google.com/maps?q=12.9104375,77.5690625+(Sana+Steel+Industries)&z=17&output=embed",
  googleReview: "https://search.google.com/local/writereview?placeid=ChIJ_ToaNvAVrjsRQo1cC5RBoio",
  googleProfile: "https://local.google.com/place?placeid=ChIJ_ToaNvAVrjsRQo1cC5RBoio",
};

export const FACTORIES = [
  {
    key: "factory-1",
    name: "Factory 1 — Ilyas Nagar",
    address: "140, Puneeth Rajkumar Road, 100 Feet Ring Rd, Ilyas Nagar, Bengaluru, Karnataka 560078",
    embed: "https://maps.google.com/maps?q=12.9104375,77.5690625+(Sana+Steel+Industries)&z=18&output=embed",
    directions: "https://www.google.com/maps/dir/?api=1&destination=12.9104375,77.5690625",
  },
  {
    key: "factory-2",
    name: "Factory 2 — Banashankari",
    address: "33, Ground Floor, Pipeline Rd, Umarbagh Layout, Banashankari, Bengaluru, Karnataka 560078",
    embed: "https://maps.google.com/maps?q=12.9099375,77.5710625+(Sana+Steel+Industries)&z=18&output=embed",
    directions: "https://www.google.com/maps/dir/?api=1&destination=12.9099375,77.5710625",
  },
];

export const IMAGES = {
  hero: "/images/hero.jpg",
  aboutWorkers: "/images/about-1.jpg",
  aboutBlueprint: "/images/about-2.jpg",
  logoMark: "/images/logo-mark.png",
  logoFull: "/images/logo-full.png",
  fallback: "/images/hero.jpg",
};

export const SEGMENTS = [
  {
    key: "residential",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "commercial",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "infrastructure",
    image:
      "https://images.unsplash.com/photo-1449034446853-66c86144b0ad?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "industrial",
    image:
      "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=900&q=70",
  },
  {
    key: "renovation",
    image:
      "https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=900&q=70",
  },
];
